function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M141.091 65.6169C142.087 63.0649 141.807 61.4885 138.912 61.4885C138.884 61.4885 137.729 61.4885 137.701 61.4885C134.552 61.5183 133.867 62.5276 132.752 65.3595C132.405 66.2475 129.797 74.1163 129.591 74.7319C128.729 77.3362 129.478 78.5134 132.091 78.5134C132.121 78.5134 133.197 78.5134 133.227 78.5134C136.027 78.5134 136.82 77.7075 137.854 74.939C138.294 73.7507 140.671 66.6877 141.091 65.6169ZM131.936 83C131.701 83 129.662 82.9925 129.437 82.9925C120.911 82.9925 120.489 77.5284 123.094 69.9953C125.894 61.8914 129.125 57 138.794 57C138.994 57 140.994 57.0075 141.186 57.0075C149.901 57.0075 150.252 62.4455 147.639 69.9972C144.85 78.0787 141.579 83 131.936 83Z",
  fill: "#0079C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M238.406 65.6169C239.404 63.0649 239.122 61.4885 236.23 61.4885C236.201 61.4885 235.044 61.4885 235.018 61.4885C231.871 61.5183 231.182 62.5276 230.069 65.3595C229.718 66.2475 227.114 74.1163 226.91 74.7319C226.047 77.3362 226.795 78.5134 229.406 78.5134C229.436 78.5134 230.513 78.5134 230.542 78.5134C233.343 78.5134 234.134 77.7075 235.169 74.939C235.611 73.7507 237.986 66.6877 238.406 65.6169ZM229.253 83C229.016 83 226.979 82.9925 226.754 82.9925C218.228 82.9925 217.806 77.5284 220.407 69.9953C223.211 61.8914 226.436 57 236.111 57C236.311 57 238.312 57.0075 238.503 57.0075C247.218 57.0075 247.567 62.4455 244.956 69.9972C242.165 78.0787 238.893 83 229.253 83Z",
  fill: "#0079C0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.735 82.4683C47.735 82.4683 43.3715 82.4683 40.6534 82.4683C37.9353 82.4683 36.5884 81.6941 36.0624 78.4033C35.5363 75.1068 32.7622 63.798 32.7622 63.798L27.2402 82.4683H21L28.6207 57.4719C28.6207 57.4719 33.154 57.4719 36.1948 57.4719C38.8681 57.4719 39.6293 58.1267 40.1945 61.0258C40.5732 62.9566 43.698 76.1422 43.698 76.1422L49.1081 57.4738H55.3539L47.735 82.4683Z",
  fill: "#0079C0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M174.532 82.4683C174.532 82.4683 170.167 82.4683 167.45 82.4683C164.736 82.4683 163.385 81.6941 162.861 78.4033C162.335 75.1068 159.563 63.798 159.563 63.798L154.041 82.4683H147.799L155.421 57.4719C155.421 57.4719 159.955 57.4719 162.994 57.4719C165.673 57.4719 166.428 58.1267 166.995 61.0258C167.374 62.9566 170.499 76.1422 170.499 76.1422L175.911 57.4738H182.151L174.532 82.4683Z",
  fill: "#0079C0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M61.0719 82.4683H52.9009L60.557 57.4719H68.73L61.0719 82.4683Z",
  fill: "#0079C0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M277.678 82.4683H269.396L277.163 57.4719H285.407L277.678 82.4683Z",
  fill: "#0079C0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M252.931 57.4719C250.993 63.8819 247.762 74.5136 245.346 82.4683C249.136 82.4683 258.878 82.4683 262.421 82.4683C263.984 82.4683 265.128 82.084 265.704 80.7893C266.376 79.2801 266.971 77.9872 266.971 77.9872H254.88L256.66 72.0063C256.66 72.0063 257.505 72.0063 260.889 72.0063C264.059 72.0063 266.057 71.4765 267.43 69.1632C267.536 68.986 268.258 67.6913 268.361 67.5011C265.529 67.5011 258.048 67.5011 258.048 67.5011L259.63 62.1302C259.63 62.1302 266.128 62.1302 267.947 62.1302C269.769 62.1302 270.991 61.4175 271.698 59.9046C272.407 58.3898 272.81 57.4738 272.81 57.4738C272.81 57.4738 257.85 57.4719 252.931 57.4719Z",
  fill: "#0079C0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M113.38 64.9621C113.348 65.0609 112.995 66.4023 112.964 66.5011C111.826 69.9934 109.824 72.1537 105.447 72.1537H103.987L107.225 61.5519H111.111C113.242 61.5519 114.128 62.494 113.38 64.9621ZM119.807 59.164C118.288 57.748 115.941 57.4719 112.518 57.4719H100.444L92.8159 82.4683C92.8159 82.4683 96.9518 82.4683 100.728 82.4683C101.828 79.0637 102.987 75.4333 102.987 75.4333C103.724 75.4333 107.479 75.4333 107.479 75.4333C114.488 75.4333 119.085 72.3496 120.931 66.4508C121.918 63.3092 121.596 60.7795 119.807 59.164Z",
  fill: "#0079C0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M86.7436 64.9621C86.7137 65.0609 86.3612 66.4023 86.3313 66.5011C85.1915 69.9934 83.1897 72.1537 78.8132 72.1537H77.3525L80.5911 61.5519H84.4751C86.6074 61.5519 87.4935 62.494 86.7436 64.9621ZM93.1704 59.164C91.6537 57.748 89.3068 57.4719 85.8873 57.4719H73.8098L66.1816 82.4683C66.1816 82.4683 70.3175 82.4683 74.0915 82.4683C75.1941 79.0637 76.3563 75.4333 76.3563 75.4333C77.0932 75.4333 80.8448 75.4333 80.8448 75.4333C87.8536 75.4333 92.4503 72.3496 94.299 66.4508C95.2822 63.3092 94.9594 60.7795 93.1704 59.164Z",
  fill: "#0079C0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M197.054 57.472L189.29 82.4683H197.571L205.3 57.472H197.054ZM217.73 57.1716C214.702 57.1716 212.54 58.1548 210.83 60.8561C207.261 66.49 205.692 68.2567 202.388 69.5924C202.673 70.3237 205.636 77.8586 206.367 79.7241C207.136 81.6904 208.468 82.4683 210.483 82.4683C212.497 82.4683 216.499 82.4683 216.499 82.4683L210.193 68.6484C213.723 67.878 215.676 66.4359 218.562 62.2216C220.047 59.8449 221.293 57.9682 222.866 57.1716C222.868 57.1716 219.286 57.1716 217.73 57.1716Z",
  fill: "#0079C0"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoNk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNk);
export default __webpack_public_path__ + "static/media/logo_nk.d0c01fa1.svg";
export { ForwardRef as ReactComponent };